window.addEventListener('load', () => {
  ScrollTrigger.refresh()
})

gsap.utils.toArray('[data-animation="fade-up"]').forEach((fadeUpElement) => {
  gsap.from(fadeUpElement, {
    scrollTrigger: {
      trigger: fadeUpElement,
      start: 'top 70%',
    },
    opacity: 0,
    y: 50,
    duration: 1,
  })
})

gsap.utils.toArray('[data-animation="fade-bottom"]').forEach((fadeBottomElement) => {
  const delay = fadeBottomElement.dataset.animationDelay ? parseFloat(fadeBottomElement.dataset.animationDelay) : 0
  gsap.from(fadeBottomElement, {
    scrollTrigger: {
      trigger: fadeBottomElement,
      start: 'top 70%',
    },
    opacity: 0,
    y: -300,
    duration: 1,
    delay: delay,
  })
})

gsap.utils.toArray('[data-animation="fade-left"]').forEach((fadeLeftElement) => {
  const delay = fadeLeftElement.dataset.animationDelay ? parseFloat(fadeLeftElement.dataset.animationDelay) : 0
  gsap.from(fadeLeftElement, {
    scrollTrigger: {
      trigger: fadeLeftElement,
      start: 'top 70%',
    },
    opacity: 0,
    x: 50,
    duration: 1,
    delay: delay,
  })
})

gsap.utils.toArray('[data-animation="pseudo"]').forEach((pseudoElement) => {
  gsap.from(pseudoElement, {
    scrollTrigger: {
      trigger: pseudoElement,
      onEnter: () => pseudoElement.classList.add('animated'),
      start: 'top center',
    },
  })
})

gsap.utils.toArray('[data-animation="fade-up-stagger"]').forEach((fadeUpSection) => {
  const delay = fadeUpSection.dataset.animationDelay ? parseFloat(fadeUpSection.dataset.animationDelay) : 0
  gsap.from(fadeUpSection.children, {
    scrollTrigger: {
      trigger: fadeUpSection,
      start: 'top 70%',
    },
    opacity: 0,
    y: 50,
    duration: 1,
    delay: delay,
    stagger: {
      each: 0.5,
    },
  })
})

gsap.utils.toArray('[data-animation="fade-left-stagger"]').forEach((fadeLeftSection) => {
  const delay = fadeLeftSection.dataset.animationDelay ? parseFloat(fadeLeftSection.dataset.animationDelay) : 0
  gsap.from(fadeLeftSection.children, {
    scrollTrigger: {
      trigger: fadeLeftSection,
      start: 'top 70%',
    },
    opacity: 0,
    x: 50,
    duration: 1,
    delay: delay,
    stagger: {
      each: 0.5,
    },
  })
})

gsap.utils.toArray('[data-animation="fade-up-stagger-reverse"]').forEach((fadeUpSection) => {
  const delay = fadeUpSection.dataset.animationDelay ? parseFloat(fadeUpSection.dataset.animationDelay) : 0
  gsap.from(fadeUpSection.children, {
    scrollTrigger: fadeUpSection,
    opacity: 0,
    y: 150,
    duration: 0.5,
    delay: delay,
    stagger: {
      each: 0.2,
      from: 'end',
    },
  })
})

// parallax
gsap.utils.toArray('[data-parallax="horizontal-parallax"]').forEach((parallaxElement) => {
  gsap.to(parallaxElement.children, {
    x: 0,
    scrollTrigger: {
      trigger: parallaxElement,
      start: 'top bottom',
      end: 'top 0',
      scrub: true,
      // markers: true,
    },
  })
})

gsap.utils.toArray('[data-parallax="vertical-parallax"]').forEach((parallaxElement) => {
  gsap.to(parallaxElement.children, {
    y: 0,
    scrollTrigger: {
      trigger: parallaxElement.parentElement,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
      // markers: true,
    },
  })
})
